import { forwardRef } from 'react';
import { WizardDrawer } from '@goodfynd/forms';
import type { DrawerRefMethods } from '@goodfynd/hooks';

import { ScheduleWizard } from './ScheduleWizard';
import type { ScheduleWizardDrawerProps, ScheduleWizardFields } from './types';

export const ScheduleWizardDrawer = forwardRef(function ScheduleWizardDrawer(
  {
    wizardProps: { vendorId, ...wizardProps },
    ...props
  }: ScheduleWizardDrawerProps,
  ref: React.ForwardedRef<DrawerRefMethods | null>
) {
  return (
    <WizardDrawer<ScheduleWizardFields>
      ref={ref}
      targetContent="Add to schedule"
      renderWizard={(props, ref) => (
        <ScheduleWizard
          {...props}
          {...wizardProps}
          ref={ref}
          title="Schedule update"
          vendorId={vendorId}
        />
      )}
      {...props}
    />
  );
});
